import ButtonStyle from "../style/button.component";
import DivStyle from "../style/div.component";
import AreaForm from "./form_area";
import FormCategory from "./form_category";
import FormCheckInput from "./form_check";
import DateListForm from "./form_date_list";
import FormDate from "./form_date_time";
import DoubleInputForm from "./form_double_input";
import FacilityForm from "./form_facility";
import FormFileInput from "./form_file";
import FormFilesVideoInput from "./form_file_video";
import FormFilesInput from "./form_files";
import FormImage from "./form_image";
import FormImagesSort from "./form_images_sort";
import FormInput from "./form_input";
import FormInputButton from "./form_input_button";
import FormInputDash from "./form_input_dash";
import LocationForm from "./form_location";
import PhoneForm from "./form_phone";
import PushCountForm from "./form_push_count";
import SearchForm from "./form_search";
import SearchGroupForm from "./form_search_group";
import FormSelect from "./form_select";
import FormTextArea from "./form_text";
import FormVideo from "./form_video";
import {
  FormProps,
  FormTempInterface,
  FormTypeProps,
} from "./interface/formInterface";

const FormTemp = (props: FormTempInterface) => {
  const { data } = props;
  const { value, label, setValue, width, type, options, disabled } = data;
  switch (type) {
    case "input":
      return (
        <FormInput
          height="20px"
          fontSize="13px"
          value={value}
          label={label}
          setValue={setValue}
          width={width}
          disabled={disabled}
        ></FormInput>
      );
    case "input-dash":
      return (
        <FormInputDash
          height="20px"
          fontSize="13px"
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></FormInputDash>
      );
    case "text":
      return (
        <FormTextArea
          height="100px"
          fontSize="13px"
          value={value}
          label={label}
          setValue={setValue}
          width={width}
          disabled={disabled}
        ></FormTextArea>
      );
    case "check":
      return (
        <FormCheckInput
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></FormCheckInput>
      );
    case "date":
      return (
        <FormDate
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></FormDate>
      );
    case "file":
      return (
        <FormFileInput
          value={value}
          label={label}
          setValue={setValue}
          width={width}
          currentImageUrl={data.currentImageUrl} // 추가
        ></FormFileInput>
      );
    case "push-count":
      return (
        <PushCountForm
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        />
      );
    case "file-video":
      return (
        <FormFilesVideoInput
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></FormFilesVideoInput>
      );
    case "select":
      return (
        <FormSelect
          options={options}
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></FormSelect>
      );
    case "search-group":
      return (
        <SearchGroupForm
          value={value}
          label={label}
          setValue={setValue}
          width={width}
          isOpen={data.isOpen}
          setIsOpen={data.setIsOpen}
        ></SearchGroupForm>
      );
    case "image":
      return (
        <FormImage
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></FormImage>
      );
    case "video":
      return (
        <FormVideo
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></FormVideo>
      );
    case "phone-form":
      return (
        <PhoneForm
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></PhoneForm>
      );
    case "area-form":
      return (
        <AreaForm
          value={value}
          label={label}
          setValue={setValue}
          width={width}
          options={options}
        ></AreaForm>
      );
    case "location-form":
      return (
        <LocationForm
          value={value}
          label={label}
          setValue={setValue}
          width={width}
          isOpen={data.isOpen}
          setIsOpen={data.setIsOpen}
        ></LocationForm>
      );
    case "facility-form":
      return (
        <FacilityForm
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></FacilityForm>
      );
    case "double-input":
      return (
        <DoubleInputForm
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></DoubleInputForm>
      );
    case "images-sort":
      return (
        <FormImagesSort
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        />
      );
    case "files":
      return (
        <FormFilesInput
          value={value}
          label={label}
          setValue={setValue}
          width={width}
          currentImageUrls={data.currentImageUrls} // 추가
          multiple={data.multiple} // 추가
        ></FormFilesInput>
      );
    case "search-form":
      return (
        <SearchForm
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></SearchForm>
      );
    case "input-button":
      return (
        <FormInputButton
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></FormInputButton>
      );
    case "category":
      return (
        <FormCategory
          value={value}
          label={label}
          setValue={setValue}
          width={width}
          options={options}
        ></FormCategory>
      );
    case "date-list":
      return (
        <DateListForm
          value={value}
          label={label}
          setValue={setValue}
          width={width}
        ></DateListForm>
      );
  }
  return null;
};
const SmallForm = (props: FormProps) => {
  const { form, title, add, remove, mode, save, cancel } = props;

  const getButtonText = (mode: string) => {
    switch (mode) {
      case "U":
        return "저장";
      case "CR":
        return "리워드 지급";
      case "S":
        return "저장";
      case "C":
        return "지급 취소";
      default:
        return "등록";
    }
  };

  // 버튼 클릭 핸들러를 결정하는 함수
  const handleButtonClick = (): void => {
    if ((mode === "U" || mode === "S" || mode === "CR") && save) {
      save();
    } else if (add) {
      add();
    }
  };

  return (
    <DivStyle
      backgroundColor="#1E1E1E"
      width="100%"
      height="calc(auto + 10px)"
      display="flex"
      flex_direction="column"
      align_items="center"
    >
      <span
        style={{
          width: "100%",
          textAlign: "center",
          fontSize: "18px",
          color: "#FFFFFFB3",
          marginTop: "30px",
        }}
      >
        {title}
      </span>
      {form.map((item: FormTypeProps, index: number) => (
        <div key={index} style={{ width: "90%", marginBottom: "20px" }}>
          <FormTemp data={item}></FormTemp>
        </div>
      ))}
      {mode
        ? mode !== "NU" &&
          mode !== "REPORT" && (
            <div>
              {(save || add) && (
                <ButtonStyle
                  onClick={handleButtonClick}
                  marginBottom="30px"
                  width={mode === "CR" ? "100px" : "70px"}
                  height="40px"
                  border="none"
                  backgroundColor="#1976D2"
                  borderRadius="5px"
                  color="white"
                >
                  {getButtonText(mode)}
                </ButtonStyle>
              )}
              {mode === "CR" && (
                <ButtonStyle
                  marginLeft="10px"
                  onClick={() => cancel()}
                  marginBottom="30px"
                  width="120px"
                  height="40px"
                  border="none"
                  backgroundColor="#DD2C00"
                  borderRadius="5px"
                  color="white"
                >
                  리워드 지급 취소
                </ButtonStyle>
              )}
              {(mode === "U" || mode === "CR") && remove ? (
                <ButtonStyle
                  marginLeft="10px"
                  onClick={() => remove()}
                  marginBottom="30px"
                  width="70px"
                  height="40px"
                  border="none"
                  backgroundColor="#DD2C00"
                  borderRadius="5px"
                  color="white"
                >
                  삭제
                </ButtonStyle>
              ) : null}
            </div>
          )
        : null}
      {mode === "NU" && remove && (
        <ButtonStyle
          marginLeft="10px"
          onClick={() => remove()}
          marginBottom="30px"
          width="70px"
          height="40px"
          border="none"
          backgroundColor="#DD2C00"
          borderRadius="5px"
          color="white"
        >
          삭제
        </ButtonStyle>
      )}

      {mode === "REPORT" && (
        <div>
          {save && (
            <ButtonStyle
              marginLeft="10px"
              onClick={() => save()}
              marginBottom="30px"
              width="70px"
              height="40px"
              border="none"
              backgroundColor="#1976D2"
              borderRadius="5px"
              color="white"
            >
              처리
            </ButtonStyle>
          )}
          {remove && (
            <ButtonStyle
              marginLeft="10px"
              onClick={() => remove()}
              marginBottom="30px"
              width="70px"
              height="40px"
              border="none"
              backgroundColor="#DD2C00"
              borderRadius="5px"
              color="white"
            >
              삭제
            </ButtonStyle>
          )}
        </div>
      )}
    </DivStyle>
  );
};

export default SmallForm;
